import dayjs from 'dayjs';
import moment from 'moment';

import { monthType } from '../constants/calendar';

export const weeksShort = {
  '0': 'SU',
  '1': 'MO',
  '2': 'TU',
  '3': 'WE',
  '4': 'TH',
  '5': 'FR',
  '6': 'SA',
} as any;

export const getDateMonthForYear = (year: string, month: monthType): string => {
  const obj: {
    [key: monthType]: string;
  } = {
    January: `${year}-01-01`,
    February: `${year}-02-01`,
    March: `${year}-03-01`,
    April: `${year}-04-01`,
    May: `${year}-05-01`,
    June: `${year}-06-01`,
    July: `${year}-07-01`,
    August: `${year}-08-01`,
    September: `${year}-09-01`,
    October: `${year}-10-01`,
    November: `${year}-11-01`,
    December: `${year}-12-01`,
  };

  return obj[month];
};

export const getTimeStr = (hours: number, minutes: number) => {
  return moment().set('hour', hours).set('minute', minutes).format('hh:mm A');
};

interface NormalizedPeriods {
  [key: string]: {
    weekdays: Array<string>;
  };
}

export const getNormalizedPeriods = (periods: any): NormalizedPeriods => {
  const periodsNormalized = {} as any;

  if (periods){
    Object.keys(periods).forEach(key => {
      const weekText = weeksShort[key];
      const periodValue = periods[key] as any;

      const timeFromStr = getTimeStr(periodValue.from.hours, periodValue.from.minutes);
      const timeToStr = getTimeStr(periodValue.to.hours, periodValue.to.minutes);

      const periodKey = `${timeFromStr}/${timeToStr}`;

      if (periodsNormalized[periodKey]) {
        periodsNormalized[periodKey].weekdays.push(weekText);
      } else {
        periodsNormalized[periodKey] = {
          weekdays: [weekText],
        };
      }
    });
  };

  // @todo refactor
  // sort 'SU' as last element
  Object.keys(periodsNormalized).forEach(key => {
    periodsNormalized[key]?.weekdays?.sort((a: string, b: string) => b === 'SU' ? -1 : 0);
  });

  return periodsNormalized;
};

export const getDaysOffFilteredByReason = (daysOff: any) => {
  const daysOffFilteredByReason = {} as any;

  daysOff?.forEach((dayOff: any) => {
    const reasonKey = dayOff.reason;

    if (daysOffFilteredByReason[reasonKey]) {
      daysOffFilteredByReason[reasonKey].push(dayOff);
    } else {
      daysOffFilteredByReason[reasonKey] = [dayOff];
    }
  });

  return daysOffFilteredByReason;
};

export const getWorkTimesForCalendar = (work: any) => {
  const timePeriods = {} as any;
  Object.keys(work?.daysPeriods || {}).forEach(key => {
    const timeKey = +key || 7;

    timePeriods[timeKey] = {
      // @ts-ignore
      from: dayjs()
        .hour(work?.daysPeriods[key].from.hours)
        .format('HH A'),
      // @ts-ignore
      to: dayjs()
        .hour(work?.daysPeriods[key].to.hours)
        .format('HH A'),
    };
  });

  return {
    startDate: work?.period?.from,
    endDate: work?.period?.to,
    // 1-mon, 2-tue, 3-wen, 4-thu, 5-fri, 6-sat, 7-sun
    weekDays: Object.keys(work?.daysPeriods || {})
      .map(key => {
        // @ts-ignore
        return key == 0 ? 7 : +key;
      })
      .sort(),
    timePeriod: timePeriods,
  };
};

export const getNormalizedWorkingTimes = (workingTimes: any) => {
  return workingTimes.map((work: any) => ({
    ...work,
    period: {
      from: dayjs(work.period.from).format('YYYY-MM-DD'),
      to: dayjs(work.period.to).format('YYYY-MM-DD'),
    },
  }));
};

export const getNormalizedDaysOff = (daysOff: any) => {
  return daysOff.map((dayOff: any) => ({
    ...dayOff,
    period: {
      from: dayjs(dayOff.period.from).format('YYYY-MM-DD'),
      to: dayjs(dayOff.period.to).format('YYYY-MM-DD'),
    },
  }));
};

export const getNormalizedHolidays = (holidays: any) => {
  return holidays.map((holiday: any) => ({
    ...holiday,
    date: dayjs(holiday.date).format('YYYY-MM-DD'),
  }));
};
